import GeneratedMailFolderServiceApi from "./generated/GeneratedMailFolderServiceApi"

class MailFolderServiceApi extends GeneratedMailFolderServiceApi {

}

export const mailFolderServiceApi = new MailFolderServiceApi()
